module.exports = __webpack_public_path__ + "img/ring_r_o_0_1@2x.8a80ddba.png";